import axios from "axios";
import config from "../config/config";
import store from "../store";

const API_URL = config.API_URL;

const getAuthHeaders = () => {
  const token = store.state.authToken || localStorage.getItem("authToken");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
};

export const getSuperAdminRevenue = async (year) => {
  const params = year ? { year } : {};
  const response = await axios.get(`${API_URL}v1/superadmin/dashboard/revenue`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

export const getSuperAdminPlatformStats = async () => {
  const response = await axios.get(`${API_URL}v1/superadmin/dashboard/platform-stats`, getAuthHeaders());
  return response.data;
};

export const getSuperAdminCompanies = async (params = {}) => {
  const response = await axios.get(`${API_URL}v1/superadmin/companies`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

export const getSuperAdminCompanyHealth = async (id) => {
  const response = await axios.get(`${API_URL}v1/superadmin/companies/${id}/health`, getAuthHeaders());
  return response.data;
};

export const getPendingBillingApprovals = async (params = {}) => {
  const response = await axios.get(`${API_URL}v1/superadmin/billing/pending-approvals`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};

export const approveBilling = async (billingId) => {
  const response = await axios.post(
    `${API_URL}v1/superadmin/billing/${billingId}/approve`,
    {},
    getAuthHeaders()
  );
  return response.data;
};

export const rejectBilling = async (billingId, reason) => {
  const response = await axios.post(
    `${API_URL}v1/superadmin/billing/reject`,
    {
      billing_id: billingId,
      reason_for_reject: reason,
    },
    getAuthHeaders()
  );
  return response.data;
};

export const getAuditLogs = async (params = {}) => {
  const response = await axios.get(`${API_URL}v1/superadmin/audit-logs`, {
    ...getAuthHeaders(),
    params,
  });
  return response.data;
};
